module.exports = __webpack_public_path__ + "img/icon_to_top.0d008f4a.svg";